<template>
  <div>
    <ProfilePage
      :user="user"
      :locationOptions="cities"
      :proposedTags="proposedTags"
      :tagOptions="topTags"
      :loading="loading"
      :isSearchingLocation="isSearchingLocation"
      :buttonText="buttonText"
      :showDefaultTags="showDefaultTags"
      @searchLocation="searchLocation"
      @saveEdits="saveEdits"
      @hide="$emit('hide')"
    />
  </div>
</template>

<script>
import { ProfilePage } from 'uicomponents';

import loggerService from '@/services/logger.service';
import { getCities } from '@/services/organization.service';

export default {
  name: 'UserProfileDialog',
  components: { ProfilePage },
  props: {
    showActions: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      cities: [],
      isSearchingLocation: false,
      loading: false
    };
  },
  computed: {
    buttonText() {
      return this.$t('@@translate@@ Save');
    },
    user() {
      return this.$store.state.user.currentEventUser || {};
    },
    event() {
      return this.$store.getters['event/currentEvent'];
    },
    proposedTags() {
      return this.$store.getters['filterBar/allPropposedTags'];
    },
    topTags() {
      return this.$store.getters['filterBar/allTopTags'];
    },
    showDefaultTags() {
      return this.$store.state?.event?.organization?.use_profile_tags;
    }
  },
  methods: {
    async searchLocation(query) {
      const cities = this.cities;
      this.isSearchingLocation = true;

      try {
        this.cities = (await getCities(query)).filter(({ place_id }) => Boolean(place_id));
        this.isSearchingLocation = false;
      } catch (e) {
        this.cities = cities;
      } finally {
        this.loading = false;
      }
    },

    saveEdits({ image, ...user }) {
      this.showloader = true;
      this.loading = true;
      this.$store
        .dispatch('updateUserProfileAndImage', { image, user })
        .then(() => {
          // Why?! You ask me why? Why don't you ask ankur why.
          // the api is not guaranteed to return the updated user
          // after you make an update, thats why
          /*
          this.$store.dispatch("loadEventUser", {
            eventID: this.$route.params.eventID,
            force: true
          });
          */
        })
        .catch(e => {
          this.loading = false;
          loggerService.error('error in saveEdits', e);
        })
        .finally(() => {
          this.loading = false;
          this.$emit('cancel');
        });
    }
  }
};
</script>
